var WishlistForm = require("./wishlist-form");
var ConditionListsPopUp = require("./condition-lists-popup");

var WishlistService = function () {
    var $currentContext = $();
    var moduleOptions = {
        currency: ""
    };

    var wishlistForm, conditionListsPopUp;

    function showNextPopUp(checkResult, checkResults, products) {
        conditionListsPopUp.hide();

        var currentCheckResultIndex = checkResults.indexOf(checkResult);
        if (checkResults.length - 1 > currentCheckResultIndex) {
            var nextCheckResult = checkResults[currentCheckResultIndex + 1];
            var nextProduct = products.find(p => p.id === nextCheckResult.productId);
            showPopUp(nextCheckResult, nextProduct, checkResults, products);
        } else {
            wishlistForm.sendProductsToCart();
        }
    }

    function showPopUp(checkResult, product, checkResults, products) {
        conditionListsPopUp.show(product, checkResult,
            () => {
                showNextPopUp(checkResult, checkResults, products);
            }, () => {
                wishlistForm.rejectProduct(product);
                showNextPopUp(checkResult, checkResults, products);
            }
        );
    }

    function processCheckResult(checkResults, entries) {
        if (checkResults.length) {
            var products = entries.map(entry => entry.getProduct());
            var checkResult = checkResults[0];
            var product = products.find(p => p.id === checkResult.productId);

            showPopUp(checkResult, product, checkResults, products);
        } else {
            wishlistForm.sendProductsToCart();
        }
    }

    function handleFormSubmit(entries) {
        if (entries.length > 0) {
            const productIds = entries.map(entry => entry.getProduct().id);

            $.ajax({
                cache: false,
                type: "GET",
                url: "/nop/conditionListProducts/checkConditions?productIds=" + productIds.join(","),
                complete: function (data) {
                    var checkResult = data.responseJSON;
                    if (checkResult.success) {
                        processCheckResult(checkResult.value, entries);
                    } else {
                        alert("An error has occurred.");
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    alert("An error has occurred.");
                },
                traditional: true
            });
        } 
    }

    function handleEntryRemoved() {
        wishlistForm.removeProductFromCart();
    }

    function bindEvents() {
        wishlistForm
            .on("form-submitted", function (entries) {
                handleFormSubmit(entries);
            })
            .on("entry-removed", function() {
                handleEntryRemoved();
            });
    }

    function parseContext() {
        var $wishlistFormContext = $(WishlistForm.SELECTOR, $currentContext);
        wishlistForm = new WishlistForm();
        wishlistForm.init($wishlistFormContext, moduleOptions);

        var $conditionListsPopUp = $(ConditionListsPopUp.SELECTOR, $currentContext);
        conditionListsPopUp = new ConditionListsPopUp();
        conditionListsPopUp.init($conditionListsPopUp);
    }

    this.init = function (context, options) {
        $currentContext = context || $currentContext;
        $.extend(moduleOptions, options);

        parseContext();
        bindEvents();
    };
};

Object.defineProperty(WishlistService, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-wishlist"
});

module.exports = WishlistService;
